import accessesIcon from '../assets/assesses/accesses.svg'
import truckIcon from '../assets/equipment/truck.svg'
import diplomaIcon from '../assets/sidemenu/diploma-active.svg'
import boxIcon from '../assets/sidemenu/box-active.svg'
import productionIcon from '../assets/home/production.svg'
import localIcon from '../assets/sidemenu/local-active.svg'
import clipboardIcon from '../assets/sidemenu/clipboard-active.svg'
import steelIcon from '../assets/home/steel.svg'
import resourceIcon from '../assets/home/resource.svg'
import serviceIcon from '../assets/home/service.svg'
import hangerIcon from '../assets/home/hanger.svg'
import lengthIcon from '../assets/home/length.svg'
import companiesIcon from '../assets/home/companies.svg'
import vendasAcoIcon from '../../src/assets/home/orders.svg'
export interface ModuleConfig {
  name: string
  path: string
  image: string
  section: string
  permission: string
  dependencies?: string[]
}

// Módulos para tenant Industrial (tenant 1 e todos os outros exceto fashion)
export const industrialModules: ModuleConfig[] = [
  {
    name: 'Certificados',
    path: 'certificates',
    image: diplomaIcon,
    section: 'Aplicações',
    permission: 'certificates',
    dependencies: ['stock']
  },
  {
    name: 'Estoque',
    path: 'stock',
    image: boxIcon,
    section: 'Aplicações',
    permission: 'stock'
  },
  {
    name: 'Produção',
    path: 'production',
    image: productionIcon,
    section: 'Aplicações',
    permission: 'production',
    dependencies: ['stock', 'orders']
  },
  {
    name: 'Vendas Aço',
    path: 'steel',
    image: vendasAcoIcon,
    section: 'Aplicações',
    permission: 'orders'
  },
  {
    name: 'Roterização',
    path: 'router',
    image: localIcon,
    section: 'Aplicações',
    permission: 'router'
  },
  
  {
    name: 'Empresas',
    path: 'companies',
    image: companiesIcon,
    section: 'Banco de dados',
    permission: 'public'
  },
  {
    name: 'Pessoas',
    path: 'people',
    image: accessesIcon,
    section: 'Banco de dados',
    permission: 'accesses'
  },
  {
    name: 'Equipamentos',
    path: 'equipment',
    image: truckIcon,
    section: 'Banco de dados',
    permission: 'equipment'
  },
  {
    name: 'Rastreio de pedidos',
    path: 'orders',
    image: clipboardIcon,
    section: 'Banco de dados',
    permission: 'orders'
  },
  {
    name: 'Serviços',
    path: 'service',
    image: serviceIcon,
    section: 'Banco de dados',
    permission: 'services'
  }
]

// Módulos específicos do tenant 2 (Fashion)
export const fashionModules: ModuleConfig[] = [
  {
    name: 'Pedidos fashion',
    path: 'fashion',
    image: hangerIcon,
    section: 'Aplicações',
    permission: 'orders'
  },
  {
    name: 'Produção fashion',
    path: 'production-fashion',
    image: productionIcon,
    section: 'Aplicações',
    permission: 'production',
    dependencies: ['orders']
  },
  
  {
    name: 'Empresas',
    path: 'companies',
    image: companiesIcon,
    section: 'Banco de dados',
    permission: 'public'
  },
  {
    name: 'Pessoas',
    path: 'people',
    image: accessesIcon,
    section: 'Banco de dados',
    permission: 'accesses'
  },
  {
    name: 'Equipamentos',
    path: 'equipment',
    image: truckIcon,
    section: 'Banco de dados',
    permission: 'equipment'
  },
  {
    name: 'Produtos',
    path: 'products',
    image: lengthIcon,
    section: 'Banco de dados',
    permission: 'products'
  }
]

// Função para verificar se o usuário tem permissão para um módulo
export function hasModulePermission(module: ModuleConfig, userPermissions: string[]): boolean {
  // Módulos públicos são sempre permitidos
  if (module.permission === 'public') {
    return true
  }
  
  // Verifica se o usuário tem a permissão principal do módulo
  const hasMainPermission = userPermissions.includes(module.permission)
  
  // Se tem a permissão principal, automaticamente tem acesso às dependências
  // Conforme especificado: "usuario precisa conseguir utilizar todo o módulo mesmo não tem a permissão de stock por exemplo"
  if (hasMainPermission) {
    return true
  }
  
  return false
}

// Função para obter módulos baseado no tenantId
export function getModulesForTenant(tenantId: number | null): ModuleConfig[] {
  // Se tenantId não definido, retornar lista vazia (caller deve aguardar tenant)
  if (tenantId === null) return []

  // Se for tenant 2 (fashion), retorna módulos fashion
  if (tenantId === 2) {
    return fashionModules
  }

  // Para tenant 1 e todos os outros, retorna módulos industriais
  return industrialModules
}

// Função para obter módulos filtrados por permissões do usuário
export function getModulesForTenantWithPermissions(tenantId: number | null, userPermissions: string[]): ModuleConfig[] {
  if (tenantId === null) return []

  const allModules = getModulesForTenant(tenantId)

  return allModules.filter(module => hasModulePermission(module, userPermissions))
}

// Função para agrupar módulos por seção com ordem específica (sem filtro de permissão)
export function getModulesBySection(tenantId: number | null) {
  if (tenantId === null) return {} as Record<string, ModuleConfig[]>

  const modules = getModulesForTenant(tenantId)
  
  const sections = modules.reduce((acc, module) => {
    if (!acc[module.section]) {
      acc[module.section] = []
    }
    acc[module.section].push(module)
    return acc
  }, {} as Record<string, ModuleConfig[]>)
  
  // Garantir ordem: Aplicações primeiro, depois Banco de dados
  const orderedSections: Record<string, ModuleConfig[]> = {}
  
  if (sections['Aplicações']) {
    orderedSections['Aplicações'] = sections['Aplicações']
  }
  
  if (sections['Banco de dados']) {
    orderedSections['Banco de dados'] = sections['Banco de dados']
  }
  
  return orderedSections
}

// Função para agrupar módulos por seção com filtro de permissões
export function getModulesBySectionWithPermissions(tenantId: number | null, userPermissions: string[]) {
  if (tenantId === null) return {} as Record<string, ModuleConfig[]>

  const modules = getModulesForTenantWithPermissions(tenantId, userPermissions)
  
  const sections = modules.reduce((acc, module) => {
    if (!acc[module.section]) {
      acc[module.section] = []
    }
    acc[module.section].push(module)
    return acc
  }, {} as Record<string, ModuleConfig[]>)
  
  // Garantir ordem: Aplicações primeiro, depois Banco de dados
  const orderedSections: Record<string, ModuleConfig[]> = {}
  
  if (sections['Aplicações']) {
    orderedSections['Aplicações'] = sections['Aplicações']
  }
  
  if (sections['Banco de dados']) {
    orderedSections['Banco de dados'] = sections['Banco de dados']
  }
  
  return orderedSections
}

// Função para verificar se o usuário pode editar o stock
export function canEditStock(userPermissions: string[]): boolean {
  return userPermissions.includes('edit-stock')
}